// for now, we only export types in this file, to be used by flow

export type ItemsSelectionConstantsType = {
  SAVE_SUCCESS: string,
  SET_SELECTION: string,
  MODIFY_SELECTION: string,
  ALLOW_MULTI_SELECT: string,
};

export type ItemsConstantsType = {
  SET_VISIBLE_RANGE: string,
  REFRESH: string,
  GET: string,
  GET_SUCCESS: string,
  GET_FAIL: string,
  RELOAD: string,
  SET_FILTER: string,
  ACTIVATE_FILTER: string,
  SET_ADVANCED_FILTER: string,
  SET_SORTORDER: string,
  MODIFY_SELECTION: string,
  ALLOW_MULTI_SELECT: string,
  REMOVE_SUCCESS: string,
  SAVE_SUCCESS: string,
  ENSURE_SELECTION_IS_VISIBLE: string,
  CLEAR: string,
  UPDATE: string,
  SET_SELECTION: string,
  OPEN: string,
  GET_FOR_OPEN_SUCCESS: string,
  GET_BY_ID_SUCCESS: string,
  FIND_SUCCESS: string
};

export type TempItemConstantsType = {
  RESET: string,
  CREATE: string,
  OPEN: string,
  GET_FOR_OPEN: string,
  GET_FOR_OPEN_BY_NAME: string,
  GET_FOR_DUPLICATE: string,
  GET_FOR_OPEN_SUCCESS: string,
  GET_FOR_DUPLICATE_SUCCESS: string,
  GET_FOR_OPEN_FAIL: string,
  GET_FOR_DUPLICATE_FAIL: string,
  OPEN_READONLY: string,
  DUPLICATE: string,
  SET_VALUE: string,
  SET_RESOURCE_VALUE: string,
  SAVE: string,
  SAVE_SUCCESS: string,
  SAVE_DUPLICATE_SUCCESS: string,
  SAVE_FAIL: string,
  SAVE_DUPLICATE_FAILURE: string,
  LOAD_FROM_FILE: string,
  LOAD_FROM_FILE_SUCCESS: string,
  LOAD_FROM_FILE_FAIL: string,
  SET_MODIFIED: string,
  UPDATE: string
};

export const DnDItemTypes = {
  PRINTSEQ_PRODITEM: 'DND_PRINTSEQ_PRODITEM',
  PRINTSEQ_LANEITEM: 'DND_PRINTSEQ_LANEITEM'
};

export const FilterMode = {
  GALLERY: 'GALLERY',
  TEMP: 'TEMP'
};
